import templateUrl from './principal-check-config-stats.html';

export const checkConfigStats = {
    templateUrl,

    bindings: {
        principal: '<',
        ladProviders: '<'
    },

    controller: class CheckConfigStatsController {
        /*@ngInject*/
        constructor(logger, PRINCIPAL, PrincipalsDA) {
            this.logger = logger;
            this.PRINCIPAL = PRINCIPAL;
            this.PrincipalsDA = PrincipalsDA;
        }

        $onInit() {
            this.invitationTypes = this.PRINCIPAL.invitationType;
            this.getCheckConfigStats();
        }

        getCheckConfigStats() {
            this.PrincipalsDA.getPrincipalCheckConfigStats(this.principal.detail.id).then(
                data => (this.principalCheckConfigStats = data),
                () => this.logger.error('error.generic')
            );
        }
    }
};
